import { ExpandableItemsListDrawer } from '../../molecules/ExpandableBarcodeList/ExpandableBarcodeList'
import { useAutoExpandFlow, type FlowProps } from '../../../hooks'
import { useStore } from '../../../store'
import type AppStore from '../../../store/AppStore'

export function useSmartphoneBoxFlow(store: AppStore): FlowProps {
  return useAutoExpandFlow(store)
}

export default function SmartphoneBoxExpandableList() {
  const store = useStore()
  const flow = useSmartphoneBoxFlow(store)
  return <ExpandableItemsListDrawer {...flow} />
}
